import React from 'react'
import StagesManager from '../../components/StagesManager';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import Responsive from '../../components/Responsive';

import { nanoid } from 'nanoid';
import MessengerList from '../../components/views/messenger/MessengerList';
import MessengerView from '../../components/views/messenger/MessengerView';
import HttpServices from '../../utils/Http.services';
import { chooseFontColor, conditionalWidth } from '../../utils/useful';
import MessengerAdminView from './MessengerAdminView';
import MessengerUserView from './MessengerUserView';
import SocketServices from '../../utils/socket.services';
import DeskAdminView from './DeskAdminView';
import store from '../../stores/storeConfig';
import DeskUserView from './DeskUserView';
import DriveAdminView from './DriveAdminView';
import DriveUserView from './DriveUserView';
import Cookies from 'universal-cookie';
import CollectionBaseAdminView from './CollectionBaseAdminView';
import CollectionBaseUserView from './CollectionBaseUserView';
import { framesConfig } from '../../variables/framesStatics';

class DriveApplet extends React.Component {
    state = {
        stage: 1,
        // colors: {
        //     primaryColor: '#f58b00',
        //     secondaryColor: '#fd980b',
        //     textColor: '#fff'
        // },
        colors: {
            primaryColor: '#FFA01C',
            secondaryColor: '#F0C000',
            textColor: '#fff'
        },
        defPage: {
            actions: [{ type: 'restore' }, { type: 'properties' }, { type: 'delete' }, { type: 'openFolder' }, { type: 'copy' }, { type: 'rename' }, { type: 'locked' }, { type: 'share' }, { type: 'starred' }, { type: 'trash' }]
        },
        
    }

    componentDidMount() {

        const cookies = new Cookies();
        let token = cookies.get('token');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }
        this.waitForId(10)



        let data = {}
        data.applet = this.props.applet


        // console.log("this.props.applet",this.props.applet)
        // console.log("this.props.frames",this.props.frames)

        // HttpServices.request('getFrames', data, (fetchResult, fetchError) => {

        //     if (fetchError) {
        //         return
        //     }

        let frames = this.props.frames
        // let framesSections = [
        //     { key: 'collections', name: '{{lang}}Collections', addNew: 'addCollection', icon: '/images/applets-icons/accounting/063-cart.svg' },
        //     { key: 'pages', name: '{{lang}}Pages', addNew: 'addPage', icon: '/images/applets-icons/accounting/063-cart.svg' },
        // ]

        if (Array.isArray(frames)) {
            // console.log('this.props.framessl',this.props.frames)
            frames.forEach(element => {

                let frameInfo = framesConfig[element.type]

                if (frameInfo) {
                    Object.entries(frameInfo)?.map(([key, value]) => {
                        element[key] = value
                        if (typeof value == 'string' && value.startsWith('{{')) {
                            let baseValue = value.replace(/{/g, '').replace(/}/g, '')
                            element[key] = element[baseValue]
                        }
                    })
                }
                if (element.type == 'collection' && Array.isArray(element.fields)) {
                    element.fields.forEach(field => {
                        if (!field.key.includes("values.")) {
                            field.key = "values." + field.key
                        }
                    })
                }
            })
        }

        let currentFrameName = frames ? frames[0]?.name : null
        this.setState({ frames, currentFrameName })
    }

    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {

            this.checkDefaultTab()
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    // this.props.actions.logoutUser()
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }


    componentDidUpdate(prevProps) {
        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                // console.log('commeerceeeeee');
                this.checkDefaultTab()
                // console.log("DKLJDJKDLQK")
            })
        }
    }

    checkDefaultTab() {


        // console.log("checkDefaultTab")
        let def = ''
        let pageType = null
        let pathname = this.props.windowData.path//window.location.pathname.split('/')

        let rootRef = this.props.route.split('/')
        // console.log('rootRef', this.props.route)
        // console.log('pathnamedrive', pathname)
        rootRef = rootRef[rootRef.length - 1]

        let pageIsValid = false
        if (rootRef.includes('admin') || pathname.includes('admin')) {
            def = 'admin'
            pageType = 'admin'
            pageIsValid = true
        }
        // console.log(def)
        // console.log(rootRef)
        // console.log(pathname)


        if (!def) {
            def = ''
        }




        if (def === '') {
            pageType = ''
            pageIsValid = true

        }
        if (pageIsValid) {

            // console.log('page123ew', pageType, def, this.props.windowData, rootRef);
            this.setState({ oldData: this.props.windowData }, () => {
                // console.log('page123ew1', pageType, def, this.props.windowData);


                this.setState({ path: def, pageType }, () => {
                    // console.log('page123ew2', pageType, def, this.props.windowData);
                    // console.log(pageType) 


                    setTimeout(() => {
                        this.setState({ page: null }, () => {
                            // console.log('page123ew3', pageType, def, this.props.windowData);
                            // console.log(pageInfo)
                            this.setState({ pageType, pageStatus: 200 }, () => {
                                // console.log('page123ew4', pageType, def, this.props.windowData);
                                if (this.stageManager) {
                                    this.stageManager.changeStage((pageType), () => {
                                        // this.pageContainer.scrollTo({ top: 0, behavior: 'smooth' })
                                    })
                                } else {

                                }
                            })
                        })
                    }, 10);
                })

                // return
            })
        } else {
            this.setState({ pageStatus: 404 })
        }

    }

    checkApplet = () => {
        this.setState({ currentApplet: this.props.applet._id })
    }
    // componentDidUpdate(prevProps) {
    //     if (this.props.data != prevProps.data) {
    //         this.init()
    //     }
    // }
    // getAppletsType = () => {
    //     let applets = []
    //     HttpServices.request('getMyAppletsType', { features: 'Drive' }, (fetchResult, fetchError) => {
    //         if (fetchError) {
    //             console.log(fetchError)
    //             return
    //         }
    //         console.log('drive fetch', fetchResult.info);
    //         let promises = []
    //         for (let i = 0; i < fetchResult.info.length; i++) {
    //             promises.push(new Promise((resolve) => {
    //                 applets.push({ name: fetchResult.info[i].applet.name, icon: fetchResult.info[i].applet?.image })
    //                 console.log('frive fetch', fetchResult.info[i].applet.name);
    //                 resolve()
    //             }))
    //         }
    //         Promise.all(promises).then(() => {
    //             this.setState({ applets: applets }, () => {
    //                 console.log('applets', this.state.applets);
    //             })
    //         })

    //     })
    // }

    selectApplet = (value) => {
        this.setState({ currentApplet: value }, () => {
            // console.log('currentapplet', this.state.currentApplet)
        })
    }

    // init = () => {
    //     this.props.setWindowInfo({ title: 'Drive', icon: '/assets/icons/portals/drive.svg' })
    //     console.log(this.props.data)
    //     let data = this.props.data
    // }

    // setData = (data, cb) => {
    //     let newData = this.state.data
    //     for (const [key, value] of Object.entries(data)) {
    //         newData[key] = value
    //     }
    //     this.setState({ data: newData }, () => {
    //         if (cb) { cb() }
    //     })
    // }

    setData = (key, value, reference, cb) => {
        if (reference == 'DriveApplet') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }

    render() {
        // let variables = {
        //     applet: this.props.applet._id,
        //     appletHub: this.props.applet.hub
        // }
        let variables = this.props.variables

        let colors = this.state.colors ?? {}
        let applet = this.props.applet
        
        if (applet?.colorType == 'sameAsHub') {
            if (this.props.user.info?.colors) {
                colors = this.props.user.info.colors
            }
        }

        if (applet?.colorType == "custom" && applet?.colors) {
            colors = applet?.colors
        }

        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`
        // console.log('variables', variables)
        return (
            <div className="w-100 h-100 window-content-radius" style={{ backgroundColor: '#F5F5F5' }}  >
                <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
                    {/* <DriveAdminView stageName={'admin'} currentApplet={this.state.currentApplet} selectApplet={this.selectApplet}
                        width={this.props.width} height={this.props.height} isApplet={true} windowData={this.props.windowData}
                        route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink}
                        goToHub={this.props.goToHub} variables={variables} setWindowInfo={this.props.setWindowInfo}
                        applets={this.state.applets} data={this.state.data} setData={this.setData}
                        adminView={this.props.adminView} language={this.props.language}
                        colors={colors}
                        page={this.state.defPage}
                        isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} permissions={this.props.permissions}
                        baseUrl={[...this.props.baseUrl, 'admin']} lastSelected={this.props.lastSelected} changeWindow={this.props.changeWindow}
                    />
                    <DriveUserView stageName={''} currentApplet={this.state.currentApplet} selectApplet={this.selectApplet}
                        width={this.props.width} height={this.props.height} isApplet={true} windowData={this.props.windowData}
                        route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink}
                        goToHub={this.props.goToHub} variables={variables} setWindowInfo={this.props.setWindowInfo}
                        applets={this.state.applets} data={this.state.data} setData={this.setData}
                        adminView={this.props.adminView} language={this.props.language}
                        colors={colors}
                        page={this.state.defPage}
                        permissions={this.props.permissions} baseUrl={[...this.props.baseUrl]} lastSelected={this.props.lastSelected}
                        isDesktop={this.props.isDesktop}
                    /> */}
                    <CollectionBaseAdminView updateFrames={this.updateFrames} updateUserSettings={this.props.updateUserSettings} userSettings={this.props.userSettings} stageName={'admin'} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} permissions={this.props.permissions} baseUrl={[...this.props.baseUrl, 'admin']} frames={this.state.frames} framesSections={this.state.framesSections} colors={colors} language={this.props.language} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} updateConnectionPermissions={this.props.updateConnectionPermissions} appletAccess={this.props.appletAccess} closeWindow={this.props.closeWindow} setData={this.setData} frameUpdateActions={this.props.frameUpdateActions} automations={this.props.automations} />
                    {/* <PageViewer userView={true} stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} colors={colors} frames={this.state.frames} framesSections={this.state.framesSections} changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height} */}

                    {/* <PagesStackNavigator
                        stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} colors={colors} frames={this.state.frames} framesSections={this.state.framesSections} changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height} */}

                    <CollectionBaseUserView userView={true} stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} colors={colors} frames={this.state.frames} framesSections={this.state.framesSections} changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height}
                        windowData={this.props.windowData} route={this.props.rootUrl} applet={this.props.applet}
                        connection={this.props.connection} user={this.props.user} setUser={this.props.setUser}
                        addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                        goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.props.changeWindow} />
                </StagesManager>

                {/* {this.props.adminView && (
                    <DriveAdminView currentApplet={this.state.currentApplet} selectApplet={this.selectApplet}
                        width={this.props.width} isApplet={true} windowData={this.props.windowData}
                        route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink}
                        goToHub={this.props.goToHub} variables={variables} setWindowInfo={this.props.setWindowInfo}
                        applets={this.state.applets} data={this.state.data} setData={this.setData}
                        adminView={this.props.adminView} language={this.props.language}
                        colors={colors}
                    />
                )}
                {!this.props.adminView && (

                    <DriveUserView currentApplet={this.state.currentApplet} selectApplet={this.selectApplet}
                        width={this.props.width} isApplet={true} windowData={this.props.windowData}
                        route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink}
                        goToHub={this.props.goToHub} variables={variables} setWindowInfo={this.props.setWindowInfo}
                        applets={this.state.applets} data={this.state.data} setData={this.setData}
                        adminView={this.props.adminView} language={this.props.language}
                        colors={colors}
                    />
                )} */}

            </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DriveApplet);